import React from 'react'

import { Box, Icon, type MediumIcon } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

type BannerProps = React.PropsWithChildren<{
  icon?: MediumIcon
}>

const Banner = ({ children, icon }: BannerProps) => {
  return (
    <Box
      gap="s6"
      width="full"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{ all: 'abs008' }}
      flexDirection="row"
      justifyContent="flexStart"
      alignItems="center"
      background="champagne400"
    >
      <Icon.Medium icon={icon ?? 'alert-circle-line'} color="grey800" />
      {children}
    </Box>
  )
}

export default observer(Banner)
